import {ConversionFactorsComponent, TenderCurrentContractComponent} from '../../../../../../pages';
import {TenderAnalyticsConversionFactorResolver, TenderAnalyticsCurrencyRatesResolver} from '../../../../../resolvers';
import { Route } from '@angular/router';
import {costOfCapitalRoute} from "./cost-of-capital";

export const tenderCurrentContractRoute: Route = {
    path: 'tender-current-contract',
    component: TenderCurrentContractComponent,
    resolve: {
    },
};
